export const GET_BRANDS_USER_PENDING = 'GET_BRANDS_USER_PENDING';
export const GET_BRANDS_USER_FULFILLED = 'GET_BRANDS_USER_FULFILLED';
export const GET_BRANDS_USER_REJECTED = 'GET_BRANDS_USER_REJECTED';
export const GET_HOME_PAGE_BRANDS_PENDING = 'GET_HOME_PAGE_BRANDS_PENDING';
export const GET_HOME_PAGE_BRANDS_FULFILLED = 'GET_HOME_PAGE_BRANDS_FULFILLED';
export const GET_HOME_PAGE_BRANDS_REJECTED = 'GET_HOME_PAGE_BRANDS_REJECTED';
export const GET_BLU_BAR_BRANDS_PENDING = 'GET_BLU_BAR_BRANDS_PENDING';
export const GET_BLU_BAR_BRANDS_FULFILLED = 'GET_BLU_BAR_BRANDS_FULFILLED';
export const GET_BLU_BAR_BRANDS_REJECTED = 'GET_BLU_BAR_BRANDS_REJECTED';
export const CLEAR_BRANDS_USER = 'CLEAR_BRANDS_USER';

export default function brandsUserReducer(
  state = {
    brands: [],
    bluBarBrands: [],
    fetching: false,
    fetched: false,
  },
  action
) {
  switch (action.type) {
    case GET_HOME_PAGE_BRANDS_PENDING:
    case GET_BRANDS_USER_PENDING: {
      return {
        ...state,
        fetching: true,
        fetched: false,
      };
    }
    case GET_HOME_PAGE_BRANDS_FULFILLED:
    case GET_BRANDS_USER_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        brands: action.payLoad.data,
        meta: action.payLoad.meta,
      };
    }
    case GET_HOME_PAGE_BRANDS_REJECTED:
    case GET_BRANDS_USER_REJECTED: {
      return {
        ...state,
        errors: action.payLoad.errors,
      };
    }
    case GET_BLU_BAR_BRANDS_PENDING: {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case GET_BLU_BAR_BRANDS_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        bluBarBrands: action.payload.data
      };
    }
    case GET_BLU_BAR_BRANDS_REJECTED: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload.errors
      };
    }
    case CLEAR_BRANDS_USER: {
      return {
        ...state,
        brands: [],
        meta: undefined,
      };
    }
    default:
  }

  return { ...state };
}
